import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  CircularProgress,
  Typography,
  useMediaQuery,
} from "@mui/material";
import "./styles.css";

import phone from "../../Assets/images/Telephone_icon 1.svg";
import mobile from "../../Assets/images/phone 4.svg";
import email from "../../Assets/images/mail_icon 1.svg";
import websiteLogo from "../../Assets/images/network_icon 1.svg";

import mapLogo from "../../Assets/images/Location.svg";
import userLogo from "../../Assets/images/Profile.svg";
import dummyUser from "../../Assets/images/dummyUser.jpg";
import whiteLogo from "../../Assets/images/Logo 2.svg";
import QRCode from "react-qr-code";
// import EmployeeQRCode from "./EmployeeQrCode";

import {
  useGetActiveEmployeeDetailsByEmployeeIdQuery,
  useGetProfilePictureByEmployeeIdQuery,
} from "../../API Services/GraphAPIs/employeeDetailsGraphAPIs";
import { useGetActiveLocationsQuery } from "../../API Services/GraphAPIs/locationAPIs";
import { useGetCompanyDetailsQuery } from "../../API Services/GraphAPIs/companyDetailsAPIs";
import { CLIENT_URL } from "../../Constans/URL";
// import { useNavigate } from "react-router";

interface EmployeeCardProps {
  employeeCode?: string;
}

const EmployeeCard: React.FC<EmployeeCardProps> = ({ employeeCode }) => {
  // const navigate = useNavigate();
  const isSmallScreen = useMediaQuery("(max-width:600px)");
  const [website, setWebsite] = useState<string>("");
  // const [phoneNo, setPhoneNo] = useState<string>("");
  const [isFlipped, setIsFlipped] = useState(false);
  const [isLoadingPhoto, setIsLoadingPhoto] = useState(false);
  const [showQRCode, setShowQRCode] = useState(true);
  const [isLoadingCardPic, setIsLoadingCardPic] = useState(false);

  const handleProfileClick = () => {
    setIsFlipped((prev) => !prev); // Toggle flip state
  };
  console.log(employeeCode, isLoadingPhoto, showQRCode, "employeeCode");

  const {
    data: employeeProfilePicturesData,
    error: employeeProfilePicturesError,
    isLoading: loadingEmployeeProfilePictures,
    refetch: refetchProfilePicture,
  } = useGetProfilePictureByEmployeeIdQuery(
    { employeeId: employeeCode ?? "" },
    { skip: !employeeCode }
  );

  const {
    data: activeEmployeeDetailsByEmployeeIdData,
    error: activeEmployeeDetailsByEmployeeIdError,
    isLoading: activeEmployeeDetailsByEmployeeIdLoading,
  } = useGetActiveEmployeeDetailsByEmployeeIdQuery(
    { employeeId: employeeCode ?? "" },
    { skip: !employeeCode }
  );
  const hasData =
    activeEmployeeDetailsByEmployeeIdData &&
    typeof activeEmployeeDetailsByEmployeeIdData === "object" &&
    !("message" in activeEmployeeDetailsByEmployeeIdData) &&
    Object.keys(activeEmployeeDetailsByEmployeeIdData).length > 0
  console.log(activeEmployeeDetailsByEmployeeIdData, "activeEmployeeDetailsByEmployeeIdData", hasData)
  const downloadUrl = employeeProfilePicturesData?.downloadUrl || dummyUser;

  const retryCountRef = useRef(0);
  const startTimeRef = useRef(performance.now());
  useEffect(() => {
    const fetchImage = () => {
      const elapsedTime = performance.now() - startTimeRef.current;

      if (!downloadUrl && retryCountRef.current < 2 && elapsedTime < 2000) {
        setIsLoadingPhoto(true);
        refetchProfilePicture();
        retryCountRef.current++;

        // Retry if still within 2 seconds
        setTimeout(fetchImage, 500); // Small delay before retry
      } else {
        setIsLoadingPhoto(false);
      }
    };

    fetchImage();
  }, [downloadUrl, refetchProfilePicture]);

  const { data: companyDetailsData } = useGetCompanyDetailsQuery({});

  const { data: locationData } = useGetActiveLocationsQuery({});
  console.log(companyDetailsData,"companyDetailsData");
  console.log(
    employeeProfilePicturesError,
    activeEmployeeDetailsByEmployeeIdError,
    loadingEmployeeProfilePictures,
    "picture"
  );
  // useEffect(() => {
  //   if (Array.isArray(companyDetailsData) && companyDetailsData.length > 0) {
  //     console.log("companyData array:", companyDetailsData);
  //     companyDetailsData.forEach((company: any, index: any) => {
  //       console.log(`company ${index}:`, company);
  //       console.log(`company ${index} fields:`, company.fields);
  //     });
  
  //     const companyWebsite = companyDetailsData[0]?.fields?.Website || "";
  //     setWebsite(companyWebsite);
  
  //     // const companyPhoneNo = companyDetailsData[0]?.fields?.CompanyTelephone || "";
  //     // setPhoneNo(companyPhoneNo);
  //   }
  // }, [companyDetailsData]);
  
  useEffect(() => {
    if (
      companyDetailsData &&
      Array.isArray(companyDetailsData.result) &&
      companyDetailsData.result.length > 0
    ) {
      const companyList = companyDetailsData.result;
  
      console.log("companyData array:", companyList);
      companyList.forEach((company: any, index: any) => {
        console.log(`company ${index}:`, company);
      });
  
      const companyWebsite = companyList[0]?.Website || "";
      setWebsite(companyWebsite);
  
      // const companyPhoneNo = companyList[0]?.CompanyTelephone || "";
      // setPhoneNo(companyPhoneNo);
    }
  }, [companyDetailsData]);
  

  const [formData, setFormData] = useState({
    name: "",
    designation: "",
    email: "",
    businessNumber: "",
    telephoneNumber: "",
    // webpageAddress: "",
    // company: "",
    //picture: null,
    // address: "",
    city: "",
    country: "",
  });

  useEffect(() => {
    retryCountRef.current = 0;
    setFormData({
      name: "",
      designation: "",
      email: "",
      businessNumber: "",
      city: "",
      country: "",
      telephoneNumber: "",
    });

    setIsLoadingPhoto(false);
  }, [employeeCode]);

  useEffect(() => {
    if (activeEmployeeDetailsByEmployeeIdData) {
      setFormData({
        name: activeEmployeeDetailsByEmployeeIdData?.NAME || "N/A",
        designation: activeEmployeeDetailsByEmployeeIdData?.DES_NAME || "N/A",
        email: activeEmployeeDetailsByEmployeeIdData?.PMAIL_ID || "N/A",
        businessNumber:
          activeEmployeeDetailsByEmployeeIdData?.LOCAL_MOBILE || "N/A",
        telephoneNumber:
          activeEmployeeDetailsByEmployeeIdData?.Telephone || "N/A",
        // picture: null,
        // address: activeEmployeeDetailsByEmployeeIdData.fields.NATIVE_ADDR,
        city: activeEmployeeDetailsByEmployeeIdData?.NAT_NAME || "N/A",
        country: activeEmployeeDetailsByEmployeeIdData?.NAT_CODE || "N/A",
      });
      setIsLoadingPhoto(false);
    }
  }, [activeEmployeeDetailsByEmployeeIdData]);

  const handleChange = (e: any) => {
    const { name, value, type, files } = e.target;
    setFormData({
      ...formData,
      [name]: type === "file" ? files[0] : value,
    });
  };

  const generateVCF = async () => {
    setIsLoadingCardPic(true);
    try {
      // Split the name into two parts
      // let name = formData.name || "";
      // if (name.length > 40) {
      //   name = name.slice(0, 40); // Truncate name to 40 characters
      // }
      // const firstName = name.slice(0, 25);
      // const lastName = name.slice(15, 40);
      const fullName = formData.name || "";
      const nameParts = fullName.split(" ");
      const firstName = nameParts[0] || "";
      const lastName = nameParts.slice(1).join(" ") || "";

      // Generate the VCF string
      let vCard = `BEGIN:VCARD\nVERSION:3.0\n`;
      vCard += `FN:${fullName}\n`; // Full name for display
      vCard += `N:${lastName};${firstName};;;\n`; // Lastname, Firstname format

      if (formData.designation) vCard += `TITLE:${formData.designation}\n`;
      if (formData.email) vCard += `EMAIL:${formData.email}\n`;
      if (formData.businessNumber) {
        const businessNumber = formData.businessNumber.startsWith("+")
          ? formData.businessNumber
          : `+${formData.businessNumber}`;
        vCard += `TEL;TYPE=HOME:${businessNumber}\n`;
      }
      if (formData.telephoneNumber)
        vCard += `TEL:${formData.telephoneNumber}\n`;
      // if (phoneNo) vCard += `TEL:${phoneNo}\n`;
      if (website) vCard += `URL:${website}\n`;

      // Add contact photo to the vCard
      if (downloadUrl) {
        const base64Image = await fetch(downloadUrl)
          .then((res) => res.blob())
          .then((blob) => {
            return new Promise<string>((resolve, reject) => {
              const reader = new FileReader();
              reader.onload = () => resolve(reader.result as string);
              reader.onerror = () => reject(new Error("Failed to load image"));
              reader.readAsDataURL(blob);
            });
          });

        vCard += `PHOTO;ENCODING=BASE64;TYPE=JPEG:${base64Image.split(",")[1]
          }\n`;
      }

      vCard += `END:VCARD`;

      // Create and download the VCF file
      const blob = new Blob([vCard], { type: "text/vcard" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = `${formData.name}_contact.vcf`;
      link.click();
    } catch (error) {
      console.error("Error generating VCF:", error);
    } finally {
      setIsLoadingCardPic(false); // Stop loader
    }
  };

  useEffect(() => {
    if (locationData?.result) {
      console.log("locationData array:", locationData.result);

      locationData.result.forEach((location: any, index: number) => {
        console.log(`Location ${index}:`, location);
        console.log(`Location ${index} fields:`, location.fields);
      });
    }
  }, [locationData]);


  // Generate QR code content dynamically
  const qrCodeData = `${CLIENT_URL}?empId=${employeeCode}`;
  // const handleQRCodeClick = () => {
  //   if (employeeCode) {
  //     navigate(`/profile?empId=${employeeCode}`); // Redirect to a new page
  //   }
  // };
  // const isDataLoading = isLoading || activeEmployeeDetailsByEmployeeIdLoading;
  // const isDataLoading =
  //   isLoading ||
  //   activeEmployeeDetailsByEmployeeIdLoading ||
  //   (isLoadingPhoto && !downloadUrl);
  // const shouldRenderDefaultCard = !employeeProfilePicturesData && !activeEmployeeDetailsByEmployeeIdData && !locationData && !companyDetailsData;

  const isDataLoading =
    activeEmployeeDetailsByEmployeeIdLoading ||
    loadingEmployeeProfilePictures ||
    (isLoadingPhoto && !downloadUrl);
  if (isDataLoading && performance.now() - startTimeRef.current < 2000) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh", // Ensure it covers the whole viewport
        }}
      >
        <CircularProgress sx={{ color: "gray", width: "50px" }} />
      </div>
    );
  }
  // const truncateText = (text: any, maxLength = 22) => {
  //   if (!text || typeof text !== "string") return ""; // Handle invalid input
  //   text = text.trim(); // Remove unnecessary spaces

  //   return text.length > maxLength
  //     ? text.substring(0, maxLength) + "..."
  //     : text;
  // };

  const splitDesignation = (text: string, maxLength: number = 25): string[] => {
    if (text.length <= maxLength) return [text];
    const words = text.match(/[^\s()]+|\(|\)|\s+/g) || []; // Preserve hyphens and parentheses separately
    let firstLine = "";
    let secondLine = "";
    let isFirstLineFilled = false;
    for (const word of words) {
      if (!isFirstLineFilled && (firstLine + word).trim().length <= maxLength) {
        firstLine += word;
      } else {
        isFirstLineFilled = true;
        secondLine += word;
      }
    }
    return [firstLine.trim(), secondLine.trim()].filter(line => line);
  };

  return (
    <>
      {/* {shouldRenderDefaultCard ? (
        <DefaultCard />
      ) : ( */}
      <Box
        sx={{
          width: isSmallScreen ? "100%" : "320px",
          backgroundColor: "#ffffff",
          // borderRadius: 4,
          boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
          overflow: "hidden",
          textAlign: "center",
          margin: "auto",
          position: "relative",
          height: "100% !important",
        }}
      >
        {/* Top Green Section */}
        <Box className="top-curve">
          {activeEmployeeDetailsByEmployeeIdData?.message === "No employee found" ? (
            <Typography
              variant="h6"
              sx={{
                color: "#ffffff",
                marginTop: "8px",
                textAlign: "center",
                paddingTop: "10px",
                fontSize: "15px",
                textTransform: "uppercase",
                fontFamily: "Helvetica",
                fontWeight: 800,
                fontStyle: "normal",
              }}
            >
              {/* No Employee Found */}
              {activeEmployeeDetailsByEmployeeIdData?.message}
            </Typography>
          ) : (
            <div className="profile-content">
              <div
                className="flip-box"
                onClick={() => setShowQRCode((prev) => !prev)}
              // onClick={handleQRCodeClick}
              >
                <div
                  className="flip-box-inner"
                  style={{
                    position: "relative",
                    width: "100%",
                    height: "100%",
                    textAlign: "center",
                    transition: "transform 0.8s",
                    transformStyle: "preserve-3d",
                    transform: isFlipped ? "rotateY(180deg)" : "rotateY(0deg)",
                  }}
                  onClick={handleProfileClick}
                >
                  <div
                    className="flip-box-front"
                    style={{
                      position: "absolute",
                      width: "100%",
                      height: "100%",
                      borderRadius: "50%",
                      backfaceVisibility: "hidden",
                    }}
                  >
                    <img
                      src={downloadUrl}
                      alt="profile"
                      loading="lazy"
                      style={{
                        width: "90px",
                        height: "90px",
                        border: "1px solid gray",
                        margin: "0px 5px 0px 8px",
                        borderRadius: "50%",
                        boxShadow: "5px 5px 12px rgb(0 0 0 / 40%)",
                        objectFit: "fill",
                      }}
                    />
                  </div>
                  <div className="flip-box-back">
                    {/* <EmployeeQRCode /> */}
                    <div
                      style={{
                        borderRadius: "50%",
                        backgroundColor: "white",
                        width: "93px",
                        height: "93px",
                        border: "1px solid gray",
                        cursor: "pointer",
                        margin: "7px",
                        boxShadow: "5px 5px 12px rgb(0 0 0 / 40%)",
                      }}
                    >
                      <QRCode
                        value={qrCodeData}
                        size={65}
                        level="H"
                        // includeMargin={true}
                        style={{ padding: "14px 2px 5px 3px" }}
                        fgColor="#000000"
                        bgColor="#ffffff"
                      />
                    </div>
                  </div>
                </div>
              </div>



              <div className="pt pl-5">
                <Typography
                  variant="h6"
                  sx={{
                    color: "#ffffff",
                    marginTop: "8px",
                    textAlign: "left",
                    paddingTop: "10px",
                    lineHeight: "1.3 !important",
                    fontSize: "15px",
                    textTransform: "uppercase",
                    fontFamily: "Helvetica",
                    fontWeight: 800,
                    fontStyle: "normal",

                    "@media (max-width: 600px)": {
                      width: "200px !important",
                    },

                    "@media (max-width: 330px)": {
                      fontSize: "15px",
                    },
                    "@media (min-device-width: 374px) and (max-device-width: 450px) and (orientation: portrait)":
                    {
                      fontSize: "13px",
                      lineHeight: "1.2 !important",
                    },
                  }}
                >
                  {formData.name}
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    color: "#ffffff",
                    // opacity: 0.8,
                    fontSize: "10px",
                    textAlign: "left",
                    marginTop: "2px",
                    fontFamily: "Helvetica",
                    fontStyle: "normal",
                    fontWeight: "500",
                    lineHeight: "1.3 !important",
                    letterSpacing: "0.01071em",
                    "@media (min-device-width: 374px) and (max-device-width: 450px) and (orientation: portrait)":
                    {
                      fontSize: "11px",
                      lineHeight: "1.2 !important",
                    },
                  }}
                >
                  {/* {truncateText(formData.designation)} */}
                  {splitDesignation(formData.designation).map((line, index) => (
                    <React.Fragment key={index}>
                      {line}
                      {index === 0 && <br />}
                    </React.Fragment>
                  ))}
                </Typography>
              </div>

            </div>
          )}

        </Box>

        <Box sx={{ padding: "15px 16px 0px 15px", height: "182px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "row",
              marginBottom: "13px",
            }}
          >
            <img
              src={mobile}
              alt="textc"
              className="iconsPart"
              onClick={() =>
                window.open(`tel:${formData.businessNumber}`, "_self")
              }
            />
            <input
              type="text"
              name="name"
              readOnly
              value={`${formData.businessNumber || ""}`}
              // value={`+${formData.businessNumber || ""}`}
              onChange={handleChange}
              style={{
                fontSize: "13px",
                height: "30px",
                fontFamily: "Helvetica",
                fontStyle: "normal",
                fontWeight: "500",
                color: "#2E5C33",
                textAlign: "left",
                flexGrow: 1,
                border: "none",
                borderRadius: "10px",
                backgroundColor: "#ECECEC",
                padding: "2px 5px 2px 45px",
                marginLeft: "7px",
              }}
            />
            {/* <TextField
            hiddenLabel
            variant="filled"
            size="small"
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            sx={{
              fontSize: "12px",
              color: "#075D31 !important",
              textAlign: "left",
              flexGrow: 1,
              borderBottom: "none",
              borderRadius: 2,
              // backgroundColor: "#E6E7E9",
              padding: "2px 5px 2px 45px",
              // padding:"3px !important"
            }}
          /> */}
            {/* <Typography
            variant="body2"
            sx={{
              fontSize: "14px",
              color: "#075D31",
              textAlign: "left",
              flexGrow: 1,
              border: "1px solid #e0e0e0",
              borderRadius: 2,
              backgroundColor: "#E6E7E9",
              padding: "2px 5px 2px 45px",
            }}
          >
            {formData.mobile}
          </Typography> */}
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "row",
              marginBottom: "13px",
            }}
          >
            <img
              src={phone}
              alt="textc"
              className="iconsPart"
              onClick={() =>
                window.open(`tel:${formData.telephoneNumber}`, "_self")
              }
            />
            <input
              type="text"
              name="number"
              readOnly
              value={`${formData.telephoneNumber || ""}`}
              // value={phoneNo}
              onChange={handleChange}
              style={{
                fontSize: "13px",
                height: "30px",
                fontFamily: "Helvetica",
                fontStyle: "normal",
                fontWeight: "500",
                color: "#2E5C33",
                textAlign: "left",
                flexGrow: 1,
                border: "none",
                borderRadius: "10px",
                backgroundColor: "#ECECEC",
                padding: "2px 5px 2px 45px",
                marginLeft: "7px",
              }}
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "row",
              marginBottom: "13px",
            }}
          >
            <img
              src={email}
              alt="textc"
              className="iconsPart"
              onClick={() => window.open(`mailto:${formData.email}`, "_self")}
            />
            <input
              type="text"
              name="email"
              readOnly
              value={formData.email}
              onChange={handleChange}
              style={{
                fontSize: "13px",
                height: "30px",
                fontFamily: "Helvetica",
                fontStyle: "normal",
                fontWeight: "500",
                color: "#2E5C33",
                textAlign: "left",
                flexGrow: 1,
                border: "none",
                borderRadius: "10px",
                backgroundColor: "#ECECEC",
                padding: "2px 5px 2px 45px",
                marginLeft: "7px",
              }}
            />
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexDirection: "row",
              marginBottom: "13px",
            }}
          >
            {companyDetailsData?.result?.map((company: any, index: number) => {
  const website = company?.Website || "";
  return (
              //  <div key={index}>
                <>
                  <img
                    src={websiteLogo}
                    alt="websitee"
                    className="iconsPart"
                    onClick={() => window.open(website, "_blank")}
                  />
                  <input
                    type="text"
                    readOnly
                    name="webpageAddress"
                    // value={company?.fields.Website}
                    value={website}
                    onChange={handleChange}
                    style={{
                      fontSize: "13px",
                      height: "30px",
                      fontFamily: "Helvetica",
                      fontStyle: "normal",
                      fontWeight: "500",
                      color: "#2E5C33",
                      textAlign: "left",
                      flexGrow: 1,
                      border: "none",
                      borderRadius: "10px",
                      backgroundColor: "#ECECEC",
                      padding: "2px 5px 2px 45px",
                      marginLeft: "7px",
                    }}
                  />
                </>
                // </div>
              );
            })}
          </div>
        </Box>
        {/* Locations Section */}
        <div className="map-point">
          <Box
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              flexDirection: "row",
              padding: "0px 13px",
              gap: "5px",
              margin: "auto",
              width: "100%",
              alignItems: "flex-start",
              flexWrap: "wrap",
            }}
          >
            {locationData?.result &&
              Array.isArray(locationData.result) &&
              locationData.result.map((location: any) => (
                <Box
                  key={location.id}
                  sx={{
                    display: "flex",
                    justifyContent: "flex-end",
                    alignItems: "center",
                    flexDirection: "column",
                    gap: 0.5,
                    color: "#006341",
                    fontSize: "12px",
                    cursor: "pointer",
                    position: "relative", // Ensure it's on top
                    zIndex: 10,
                    height: "auto", // Adjust height based on content
                    paddingTop: "10px",
                    textAlign: "center",
                  }}
                >
                  <a
                    href={
                      location.fields?.MapLocation?.startsWith("http")
                        ? location.fields.MapLocation
                        : `https://${location.fields?.MapLocation || "google.com"
                        }`
                    }
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      cursor: "pointer",
                      textDecoration: "none",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      gap: "4px",
                      textAlign: "center",
                      width: "80px",
                    }}
                  >
                    <img src={mapLogo} alt="info" className="map-icon" />

                    <p
                      style={{
                        fontSize: "13px",
                        margin: "0px",
                        // width: "50px",
                        fontWeight: "500",
                        padding: "0px",
                        textDecoration: "none",
                        fontFamily: "Helvetica",
                        fontStyle: "normal",
                        color: "#2E5C33",

                        wordWrap: "break-word",
                        wordBreak: "break-word",
                        whiteSpace: "normal",
                        lineHeight: "1.2",
                      }}
                    >
                      {location.fields?.CompanyLocationName || "No Location Name"}
                      {/* {truncateLocation(
                      location.fields?.CompanyLocationName || "No Location Name"
                    )} */}
                    </p>
                  </a>
                </Box>
              ))}
          </Box>
        </div>

        {/* Bottom Green Section */}
        <div className="mt-40">
          <Box className="bottom-curve">
            <div>
              <img src={whiteLogo} alt="logo" className="logo" />
              {/* <p className="logo-text">{formData.company} </p> */}
              {isLoadingCardPic && (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "50px", // Adjust size to fit design
                  }}
                >
                  <CircularProgress
                    sx={{ color: "gray", width: "30px", height: "30px" }}
                  />
                </div>
              )}
              <div
                className="user-part"
                onClick={hasData ? generateVCF : undefined}
                style={{
                  pointerEvents: hasData ? "auto" : "none",
                  opacity: hasData ? 1 : 0.5,
                }}
              >
                <img src={userLogo} alt="user" className="user-logo" />
                <p
                  style={{
                    fontSize: "10px",
                    padding: "1px 10px",
                    margin: "0px",
                    fontFamily: "Helvetica",
                  }}
                >
                  Add Contact
                </p>
              </div>


            </div>
          </Box>
        </div>
      </Box>
      {/* )} */}
    </>
  );
};
export default EmployeeCard;